export default {
  production_suite: "Production Suite",
  production_suite_plus: "Production Suite+",
  alcolyzer_selzer: "Basic Suite",
  gas_analysis: "Packaging Suite",
  chemistry__acetic_acid: "Acetic Acid",
  chemistry__lactic_acid: "Lactic Acid",
  chemistry__fermentable_sugars: "Fermentable Sugars",
  chemistry__sulfur_dioxide: "Sulfur Dioxide",
  chemistry__free_amino_nitrogen: "Free Amino Nitrogen",
  chemistry__vicinal_diketones: "VDK",
  chemistry__acetaldehyde: "Acetaldehyde",
  simple_nutrition: "Nutrition Panel",
  simple_nutrition__polyphenols: "Polyphenol",
  simple_nutrition__starch: "Starch",
  microservices__pcr_yeast_analysis: "qPCR Yeast Analysis",
  microservices__pcr_bacteria_analysis: "qPCR Bacteria Analysis",
  microservices__shelf_life_analysis: "Shelf Analysis",
  microservices__plate_analysis: "Plating (Single Media)",
  microservices__pcr_and_plate_analysis: "Plating (Comprehensive Media)",
  microservices__pasteurization_analysis: "Pathogen Organisms"
};
